import { ComponentProps, FC } from 'react';
import { isClosed } from '../../../utils/booking';
import { useTranslation } from '../../../utils/i18n';
import BookingSlots from '../../bookingSlots';
import TimeslotWidget from '../../timeslotWidget';
import ClosedSlot from './closedSlot';

type TimeslotWidgetProps = ComponentProps<typeof TimeslotWidget>;
type BookingSlotsProps = ComponentProps<typeof BookingSlots>;

interface OpeningTimes {
  [key: string]: string;
}

interface Closure {
  startDate: string;
  endDate: string;
}

// FIXME: This doesn't work with babel
// interface Space extends Required<BookingSlotsProps>['spaces'][number]
interface Space {
  id: number;
  openingTimes: OpeningTimes;
}

interface Venue {
  openingTimes: OpeningTimes;
  closures: Closure[];
}

type Props = Omit<TimeslotWidgetProps, 'spaces'> &
  Omit<BookingSlotsProps, 'spaces'> & {
    // Undefined until the user has picked a date; the field renders closed.
    date?: string;
    venue: Venue;
    spaces?: Space[];
    clinical: boolean;
  };

const SlotsField: FC<Props> = ({ clinical, date, venue = {}, ...props }) => {
  const { t } = useTranslation('common');
  const { startTime, endTime, spaces = [], slots = [] } = props;

  if (
    !startTime ||
    !endTime ||
    isClosed(date, venue.openingTimes, venue.closures) ||
    spaces.some(space => isClosed(date, space.openingTimes))
  )
    return <ClosedSlot />;

  if (clinical && slots.length === 0)
    return <ClosedSlot label={t('quick_book.timeslot_widget.unavailable')} />;

  return clinical ? <BookingSlots {...props} /> : <TimeslotWidget {...props} />;
};

export default SlotsField;
